import React, { useEffect, useState } from "react";
import SidebarLayout from "../../../common/sidebar/SidebarLayout";
import { Helmet } from "../../../common/Helmet";
import { ReactComponent as DownloadIcon } from "../../../../assets/icons/TestAccounts.svg";
import OPSPrimaryHeader from "../../../common/primaryHeader/OPSPrimaryHeader";
import PatientLoader from "../../../common/PatientLoader";
import PatientListDataTable from "./PatientsListDataTable";
import { useSelector } from "react-redux";
import { patientNoStateLogic } from "../../../../store/features/patient/patientSlice";
import { notify } from "../../../../util/helpers";

const PatientsList = () => {
  const [loading, setLoading] = useState(true);
  const [patientData, setPatientData] = useState([]);
  const [patientDataCount, setPatientDataCount] = useState(0);
  const [hideDemoAccounts, setHideDemoAccounts] = useState(false);
  const [last30Days, setLast30Days] = useState(false);
  const { user } = useSelector((state) => state.app);

  useEffect(() => {
    if (!user) {
      return;
    }
    // if (patientData?.length === 0) {
    console.log(user?.clinic?.id);
    patientNoStateLogic({
      page_size: 1000,
      page: 1,
      clinic_id: user?.clinic?.id,
    })
      .then((res) => {
        setPatientDataCount(res?.data?.count);
        setPatientData(res?.data?.results);
        setLoading(false);
      })
      .catch((e) => {
        console.log("Error getting patient data from API", e);
        notify(
          "Something went wrong while fetching all patients data!",
          "error"
        );
        setLoading(false);
      });
    // }
  }, [user]);

  return (
    <SidebarLayout>
      <section className="contianer-fluid px-5 py-2">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Patient List | Precise Digital</title>
          <link rel="canonical" href={window.location.origin} />
        </Helmet>
        <div
          className="container-fluid px-3 d-flex justify-content-between"
          style={{ alignContent: "center", alignItems: "center" }}
        >
          <OPSPrimaryHeader
            titleText={`Patient List`}
            showSubtitle={false}
            showButton={false}
            showPill={true}
            pillText={`${patientDataCount} Entries`}
          />
          <div
            className="d-flex"
            style={{
              gap: "20px",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <button className="primary-btn d-flex" style={{ gap: "10px" }}>
              <DownloadIcon /> Download
            </button>
          </div>
        </div>

        <div
          className="d-flex my-2"
          style={{
            gap: "20px",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <div className="d-flex " style={{ gap: "10px" }}>
            <label className="switch-small">
              <input
                disabled={false}
                onChange={() => {
                  setHideDemoAccounts(!hideDemoAccounts);
                }}
                checked={hideDemoAccounts}
                type="checkbox"
              />
              <span className="slider-small round"></span>
            </label>
            <span className="muted-text">Show Demo Accounts</span>
          </div>

          <div className="d-flex " style={{ gap: "10px" }}>
            <label className="switch-small">
              <input
                disabled={false}
                onChange={() => {
                  setLast30Days(!last30Days);
                }}
                checked={last30Days}
                type="checkbox"
              />
              <span className="slider-small round"></span>
            </label>
            <span className="muted-text">Patient Active in Last 30 Days</span>
          </div>
        </div>

        {loading ? (
          <PatientLoader text="Fetching all patients. This may take a while..." />
        ) : (
          <PatientListDataTable
            hideDemoAccounts={hideDemoAccounts}
            last30Days={last30Days}
            data={patientData}
            loading={loading}
          />
        )}
      </section>
    </SidebarLayout>
  );
};

export default PatientsList;
